import LineCalendarIcon from 'LuxKit/Icons/line/LineCalendarIcon'
import LineClockDollarIcon from 'LuxKit/Icons/line/LineClockDollarIcon'
import LineCrownIcon from 'LuxKit/Icons/line/LineCrownIcon'
import LineUsdCircleIcon from 'LuxKit/Icons/line/LineUsdCircleIcon'
import React from 'react'

export function getHotelValueContentSection() {
  return [
    {
      key: 'bestPrice',
      heading: 'Best price guarantee',
      body: 'We negotiate the best prices so you don\'t have to. If you find a better price, we\'ll match it.',
      icon: <LineUsdCircleIcon />,
      show: true,
      link: {
        text: 'Learn more',
        href: '/best-price-guarantee',
      },
    },
    {
      key: 'changeOfMind',
      heading: '7-day change of mind refund',
      body: 'Get a full refund on your booking (excludes cruises, flights, travel protection and the service fee paid on deposit bookings)',
      icon: <LineClockDollarIcon />,
      show: true,
    },
    {
      key: 'buyNowChooseLater',
      heading: 'Buy now, choose dates later',
      body: "Lock in a deal today, choose dates when you're ready",
      icon: <LineCalendarIcon />,
      show: true,
      link: {
        text: 'Learn more',
        href: '/buy-now-book-later',
      },
    },
    {
      key: 'vipInclusion',
      heading: 'VIP Inclusions',
      body: 'You get a lot more than just a bed in a room',
      icon: <LineCrownIcon />,
      show: true,
    },
  ]
}
